import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import FormGroup from '@material-ui/core/FormGroup';
import RepairList from '../components/RepairList'
import Typography from '@material-ui/core/Typography';

import getSubgroup from '../data/getSubgroup';
import getRepairs from '../data/getRepairs';
import getColumns from '../data/getColumns';


const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: `0 ${theme.spacing.unit * 3}px`,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
  option: {
    margin: `${theme.spacing.unit * 7}px 0`,
  },
});


class PageFormatForm extends React.Component {

  state = {}

  render = () => {
    const {classes, order, actions} = this.props
    const pricingFormat = order.pricingFormat

    return (
      <div>
        <Grid container>
          <Grid item sm={12} md={12}>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup
                role="radiogroup"
                aria-label="Page Format"
                name="pricingFormat"
                onChange={(e) => { actions.setPricingFormat(order, e.target.value) }}
              >
                <RadioButtonOption
                  className={classes.option}
                  value="Agreement Reg-OT"
                  current={pricingFormat}
                  label={<span>Maintenance Agreement Regular and After Hours <span style={{color: 'green', fontStyle: 'italic'}}>(Recommended)</span></span>}
                />
                {/* <RadioButtonOption
                  className={classes.option}
                  value="Agreement Savings"
                  current={pricingFormat}
                  label="Maintenance Agreement Savings"
                />
                <RadioButtonOption
                  className={classes.option}
                  value="Primary Additional"
                  current={pricingFormat}
                  label="Primary + Additional"
                /> */}
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item sm={12} md={6}>
            <RepairList
              focusOnPrices={true}
              subgroup={getSubgroup(order)}
              repairs={getRepairs(order)}
              columns={getColumns(order)}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <Typography variant="body2" component="div" style={{margin: '2em'}}>
            {
              pricingFormat === 'Agreement Savings'
              ?
                <React.Fragment>
                  Use this price page format if your company:
                  <ul>
                    <li>Charges different rates for regular hours and after hours.</li>
                    <li>Sells Maintenance Agreements offering discounted repair fees.</li>
                    <li>Want to show Maintenance Agreement Savings to help your technicians sell more agreements.</li>
                  </ul>
                </React.Fragment>
              :
              pricingFormat === 'Agreement Reg-OT'
              ?
                <React.Fragment>
                  Use this price page format if your company:
                  <ul>
                    <li>Charges different rates for regular hours and after hours.</li>
                    <li>Sells Maintenance Agreements offering discounted repair fees.</li>
                    <li>Applies your Maintenance Agreement discount to both Regular or After Hours rates.</li>
                  </ul>
                </React.Fragment>
              :
              pricingFormat === 'Primary Additional'
              ?
                <React.Fragment>
                  Use this price page format if your company:
                  <ul>
                    <li>Charges different rates for regular hours and after hours.</li>
                    <li>Offers a discount on "Additional" repairs.</li>
                    <br/>
                  </ul>
                </React.Fragment>
              :
              null
            }
            </Typography>
          </Grid>
        </Grid>
      </div>
    )
  }
}

PageFormatForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default withStyles(styles)(PageFormatForm);



const radioStyles = theme => ({
  label: {padding: theme.spacing.unit}
})

function RadioButtonOptionCore(props) {
  return (
    <FormControlLabel
      classes={{label: props.classes.label}}
      label={props.label}
      value={props.value}
      control={ <Radio checked={props.current === props.value}/> }
      onChange={props.onChange}
    />
  )
}

const RadioButtonOption = withStyles(radioStyles)(RadioButtonOptionCore)
